const mediaItems = [
  {
    title: '《星际迷航：新纪元》终极预告',
    desc: '探索未知宇宙，人类命运悬于一线。史诗级科幻巨制，震撼视效不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20movie%20scene%20with%20starship%20flying%20through%20nebula%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20wide%20shot%2C%20deep%20space%20background%20with%20colorful%20galaxy%2C%20professional%20film%20still%20aesthetic&width=800&height=450&seq=media-1&orientation=landscape'
  },
  {
    title: '《迷雾追踪》幕后制作特辑',
    desc: '导演携主创深度解析悬疑片拍摄内幕，还原烧脑剧情的创作历程。',
    img: 'https://readdy.ai/api/search-image?query=Film%20making%20behind%20the%20scenes%20with%20director%20and%20crew%20on%20movie%20set%2C%20warm%20lighting%2C%20professional%20camera%20equipment%2C%20mystery%20thriller%20atmosphere%2C%20cinematic%20production%20environment&width=800&height=450&seq=media-2&orientation=landscape'
  },
  {
    title: '暑期档观影指南：十大必看佳片',
    desc: '精心盘点暑期最值得期待的院线与网络新片，帮你做好观影计划。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20collection%20with%20colorful%20film%20posters%20displayed%2C%20bright%20sunlight%2C%20popcorn%20and%20drinks%2C%20vibrant%20and%20exciting%20atmosphere%2C%20cinema%20lifestyle%20photography&width=800&height=450&seq=media-3&orientation=landscape'
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            最新预告片与独家特辑，提前锁定你的下一部心头好
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-100 relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}